import { ChecklistItemData } from "./checklistModel"
import API from '../api'

export type LoadChecklistResult = {
  showChecklist: boolean
  checklistPrimaryGoal: string | null
  checklistPrimaryGoalDate: string | null
  checklistPrimaryGoalCompletedDate: string | null
  steps: ChecklistItemData[]
}

export type SaveChecklistPayload = {
  steps: ChecklistItemData[]
}

export type SavePrimaryGoalPayload = {
  checklistPrimaryGoal: string | null
  checklistPrimaryGoalDate: string | null
}

export type SavePrimaryGoalCompletedDatePayload = {
  checklistPrimaryGoal: string | null
  checklistPrimaryGoalCompletedDate: string | null
}

export type AdminSearchParameters = {
  page: number
  pageSize: number
  query?: string
  orderBy?: string
  orderAscending?: boolean
  showChecklistFilter?: string
}

export type AdminSearchChecklist = {
  updatedAt: string
  steps: ChecklistItemData[]
  completedSections: number
  completedSteps: number
}

export type AdminSearchResult = {
  tenantId: number
  tenantName: string
  showSuccessChecklist: boolean
  checklist: AdminSearchChecklist | null
  checklistPrimaryGoal: string | null
  checklistPrimaryGoalDate: string | null
  checklistPrimaryGoalCompletedDate: string | null
}

export type AdminSearchResponse = {
  totalCount: number
  results: AdminSearchResult[]
}

export const successChecklistEndpoint = '/web/success-checklist'
export const adminSearchEndpoint = '/web/success-checklist/admin-search'
export const primaryGoalEndpoint = '/web/success-checklist/primary-goal'
export const primaryGoalCompletedEndpoint = '/web/success-checklist/primary-goal/completed'

export const loadSuccessChecklist = async ():Promise<LoadChecklistResult> => {
  return (await API.get(successChecklistEndpoint)).data
}

export const saveSuccessChecklist = async (payload: SaveChecklistPayload): Promise<void> => {
  await API.post(successChecklistEndpoint, payload)
}

export const saveChecklistPrimaryGoal = async (payload: SavePrimaryGoalPayload): Promise<void> => {
  await API.post(primaryGoalEndpoint, payload)
}

export const saveChecklistPrimaryGoalCompletedDate = async (payload: SavePrimaryGoalCompletedDatePayload): Promise<void> => {
  await API.post(primaryGoalCompletedEndpoint, payload)
}

export const adminSearch = async (searchParameters: AdminSearchParameters): Promise<AdminSearchResponse> => {
  return (await API.get(adminSearchEndpoint, {params: searchParameters})).data
}